package it.maicol07.gamerlogue

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.ClipEntry
import com.raedghazal.kotlinx_datetime_ext.Locale
import com.raedghazal.kotlinx_datetime_ext.initPlatformLocales

@Composable
actual fun SystemBarsVisible(visible: Boolean) {
    // No-op on web
}

@Composable
actual fun NavigationBarContrastEnforced(enforced: Boolean) {
    // No-op on web
}

@JsModule("date-fns/locale/en-US")
external object DateFnsLocaleEn

@JsModule("date-fns/locale/it")
external object DateFnsLocaleIt

fun webAppInit() {
    Locale.initPlatformLocales(DateFnsLocaleEn, DateFnsLocaleIt)
}

@Composable
actual fun appLanguageSettingsOpener(): () -> Unit = {
    // No-op on web, as the language is determined by the browser settings
}

actual fun clipEntryFor(string: String) = ClipEntry.withPlainText(string)

@Composable
actual fun deviceSeedColor(): Color? = null // No system palette on web

actual fun applyAppLanguage(tag: String?) {
    // No-op on web: the browser decides the language, as it does for the rest of the page.
}

actual val isAndroidEmulator = false
